import {
  SEARCH_INTERNSHIP_REFINEMENT_TYPES,
  SearchInternshipRefinementType,
} from './searchInternshipRefinementTypes';
import {
  SEARCH_JOBS_REFINEMENT_TYPES,
  SearchJobsRefinementType,
} from './searchJobsRefinementTypes';

export type SearchRefinementType =
  | SearchJobsRefinementType
  | SearchInternshipRefinementType;

export const SEARCH_REFINEMENT_TYPES = {
  JOB: SEARCH_JOBS_REFINEMENT_TYPES,
  INTERNSHIP: SEARCH_INTERNSHIP_REFINEMENT_TYPES,
  VOLOP: ['TODO'],
  EVENT: ['TODO'],
  ORG: ['TODO'],
} as const;
